import { useFetchPrefecturesOptions } from "@lhd/hooks";
import CommonSelector from "@lhd/components/CommonSelector";
import { ICommonFieldProps } from "../../../../interfaces";
import { useEffect, useState } from "react";

const PrefectureEditCell = (props: ICommonFieldProps) => {
  const { defaultValue, onChange } = props;
  const { data: prefectureOptions, isLoading } = useFetchPrefecturesOptions();
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  return (
    <CommonSelector
      value={value}
      options={prefectureOptions?.map((x) => {
        return {
          value: x.label,
          label: x.label,
        };
      })}
      loading={isLoading}
      height="calc(100% - var(--cell-vertical-spacing))"
      showSearch
      optionFilterProp="label"
      allowClear
      onChange={(nextValue) => {
        setValue(nextValue);
        onChange?.(nextValue ?? "");
      }}
    />
  );
};

export default PrefectureEditCell;
